<template functional>
  <div :class="['RowFlex', data.class, data.staticClass]">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
$_gutter: $grid-gutter-width;
$_gutter-half: ($_gutter / 2);

.RowFlex {
  align-items: flex-end;
  display: flex;
  flex-flow: row nowrap;
  // flex-wrap: wrap;
  justify-content: space-between;

  > div, > a, > button {
    align-content: flex-end;
    flex: 1 1 auto;
    margin: 0 $_gutter-half;
  }

  &.constrainButtons {
    > button, > a {
      max-width: fit-content;
    }
  }
}
</style>
